// components
import RoomsPage from '../components/roomsPage';
import { serverSideTranslations } from '../lib/serverSideTranslations';
import { useTranslation } from '../utils/i18n';

const BookExaminationRoomsPage = () => {
  const { t } = useTranslation('common');

  return (
    <RoomsPage
      roomType="examination"
      title={t('room_types_landing_page.examination.title')}
      roomCategory={t('shared.clinical').toLowerCase()}
      headerTitle={t('headers.examination_rooms.title')}
      headerDescription={t('headers.examination_rooms.description')}
    />
  );
};

export const getServerSideProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default BookExaminationRoomsPage;
